export default __webpack_public_path__ + "static/media/Chimes of the Black Wind.e812d370.jpg";